import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '../pipes/pipes.module';

import { PlaceholderImageDirective } from './placeholder-image.directive';
import { MarathonLogoComponent }     from './marathon-logo/marathon-logo.component';
import { BannerDebatemaComponent }   from './banner-debatema/banner-debatema.component';

import { IconsModule } from '@shared/icons/icons.module';
import { GenericBannerComponent } from './generic-banner/generic-banner.component';
import { RouterModule } from '@angular/router';
import { MarathonBannerComponent } from './marathon-banner/marathon-banner.component';


@NgModule({
  declarations: [
    PlaceholderImageDirective,
    MarathonLogoComponent,
    BannerDebatemaComponent,
    GenericBannerComponent,
    MarathonBannerComponent
  ],
  imports:      [
    CommonModule,
    PipesModule,
    IconsModule,
    RouterModule
  ],
  exports:      [
    PlaceholderImageDirective,
    MarathonLogoComponent,
    BannerDebatemaComponent,
    GenericBannerComponent,
    MarathonBannerComponent
  ],
})
export class ImageModule {}
